import * as markdowns from "@/modules/help/bundles/BUNDLED_MARKDOWNS";

const HELP_TABS = Object.freeze([
    { module: "0. WORK-Einleitung", text: markdowns.Allgemein },
    { module: "1. Zeiterfassung", text: markdowns.Zeiterfassung, id: 'ZEITERFASSUNG' },
    { module: "1.2. Arbeitszeit importieren", text: markdowns.Arbeitszeit_importieren },
    { module: "1.3. Anwesenheitstypen", text: markdowns.Anwesenheitstypen, id: 'ANWESENHEITSTYPEN' },
    { module: "1.4. Arbeitstag-Konfiguration", text: markdowns.Arbeitstag_Konfiguration },
    { module: "1.5 Anwesenheitsmanagement", text: markdowns.Anwesenheitsmanagement, id: 'ANWESENHEITSMANAGEMENT' },
    { module: "2. Projektverwaltung", text: markdowns.Anfragen },
    { module: "2.2 Projekte", text: markdowns.Projekte, id: 'PROJEKTE' },
    { module: "2.3 Ressourcenplanung", text: markdowns.Ressourcenplanung },
    { module: "2.4 Produkte", text: markdowns.Produkte, id: 'PRODUKTE' },
    { module: "2.5 Vorlagen", text: markdowns.Vorlagen_Projekte },
    { module: "2.6.1 Kunden", text: markdowns.Kunden, id: 'KUNDEN' },
    { module: "2.6.2 Projekte", text: markdowns.Projekte_Ref },
    { module: "2.6.3 Eigenschaften", text: markdowns.Eigenschaften, id: 'EIGENSCHAFTEN' },
    { module: "3. Abrechnungen", text: markdowns.Stundenabrechnung, id: 'STUNDENABRECHNUNG' },
    { module: "3.2 Projektabrechnung", text: markdowns.Projektabrechnung, id: 'PROJEKTABRECHNUNG' },
    { module: "3.3 Zahlungen", text: markdowns.Zahlungen },
    { module: "3.4 Rechnungsübersicht", text: markdowns.Rechnungsuebersicht, id: 'RECHNUNGSUEBERSICHT' },
    { module: "3.4.2 Rechnungsprüfung", text: markdowns.Rechnungspruefung },
    { module: "3.5 Vorlagen", text: markdowns.Vorlagen_Abrechnung },
    { module: "3.6. Reisekostenabrechnung", text: markdowns.Reisekostenabrechnung },
    { module: "4. Monat", text: markdowns.Uebersicht },
    { module: "4.2. Kalenderansicht", text: markdowns.Kalenderansicht, id: 'KALENDERANSICHT' },
    { module: "4.3 Abschluss", text: markdowns.Abschluss },
    { module: "4.4. Saldobearbeitung", text: markdowns.Saldobearbeitung },
    { module: "4.5. Bestätigung", text: markdowns.Bestaetigung },
    { module: "4.6. Wiedereröffnung", text: markdowns.Wiedereroeffnung },
    { module: "4.7 Abrechnungsbelege", text: markdowns.Abrechnungsbelege },
    { module: "4.8. Monatsprüfung", text: markdowns.Monatspruefung },
    { module: "4.9. Abwesenheiten", text: markdowns.Abwesenheiten },
    { module: "5. Auswertungen", text: markdowns.Abwesenheitsuebersicht, id: 'ABWESENHEITSUEBERSICHT' },
    { module: "5.2. Abwesenheitsauswertung", text: markdowns.Abwesenheitsauswertung },
    { module: "5.3. Projektstunden", text: markdowns.Projektstunden },
    { module: "5.4. Projektbudget", text: markdowns.Projektbudget },
    { module: "5.5.Jubiläen", text: markdowns.Jubilaeen },
    { module: "5.6. Monatsstunden", text: markdowns.Beschaeftigungsgruppen_Monatsstunden },
    { module: "5.6.1 Mitarbeiter", text: markdowns.Mitarbeiter, id: 'MITARBEITER' },
    { module: "5.7 Stundensalden (Änderungen)", text: markdowns.Stundensalden_Aenderungen },
    { module: "5.8 Stundensalden (Monatlich)", text: markdowns.Stundensalden_Monatlich },
    { module: "5.9 Wochenende/Feiertag", text: markdowns.Wochenende_Feiertage },
    { module: "5.10. Umsatz", text: markdowns.Umsatz },
    { module: "5.11. Budget-Report", text: markdowns.Budget_Report },
    { module: "6. Urlaubsverwaltung", text: markdowns.Urlaubsverwaltung, id: 'URLAUBSVERWALTUNG' },
    { module: "6.2. Übersicht", text: markdowns.Uebersicht, id: 'UEBERSICHT' },
    { module: "6.3. Vertretung bestätigen", text: markdowns.Vertretung },
    { module: "6.4. Antrag genehmigen", text: markdowns.Antrag_genehmigen },
    { module: "6.5. Urlaubsansprüche", text: markdowns.Urlaubsansprueche },
    { module: "6.6 Urlaubsstops", text: markdowns.Urlaubsstops, id: 'URLAUBSSTOPS' },
    { module: "6.7 Urlaubsstops Kalender", text: markdowns.Urlaubsstop_Kalender, id: 'URLAUBSSTOP_KALENDER' },
    { module: "7. Krankmeldungen", text: markdowns.Krankmeldungen },
    { module: "8. Feiertagsverwaltung", text: markdowns.Feiertage },
    { module: "8.2. Kalender", text: markdowns.Kalender },
    { module: "8.3. Bundesländer", text: markdowns.Bundeslaender },
    { module: "9. Personalverwaltung", text: markdowns.Benachrichtigungen },
    { module: "9.1.1 Personalverwaltung", text: markdowns.Krankheit },
    { module: "9.1.2. Urlaub ", text: markdowns.Urlaub },
    { module: "9.1.3. Anlässe", text: markdowns.Anlaesse },
    { module: "9.1.4. Probezeit", text: markdowns.Probezeit },
    { module: "9.1.5. Befristung", text: markdowns.Befristung },
    { module: "9.1.6. Anwesenheit ", text: markdowns.Anwesenheit, id: 'ANWESENHEIT' },
    { module: "9.2. Organisation", text: markdowns.Abteilungen, id: 'ABTEILUNGEN' },
    { module: "9.2.2.Beschäftigungsgruppen", text: markdowns.Beschaeftigungsgruppen, id: 'BESCHAEFTIGUNGSGRUPPEN' },
    { module: "9.2.3.Gruppen", text: markdowns.Gruppen, id: 'GRUPPEN' },
    { module: "9.2.4.Pausenregelungen", text: markdowns.Pausenregelungen },
    { module: "9.2.5.Stellvertretungstypen", text: markdowns.Stellvertretungstypen },
    { module: "9.2.6. Überstundenmodelle", text: markdowns.Ueberstundenmodelle, id: 'UEBERSTUNDENMODELLE' },
    { module: "9.3 Mitarbeiter", text: markdowns.Mitarbeiter },
    { module: "9.4. Lebenslauf", text: markdowns.Lebenslauf, id: 'LEBENSLAUF' },
    { module: "9.4.1 Lebenslauf", text: markdowns.Lebenslaufverwaltung },
    { module: "9.4.1.1 Ausbildung und Werdegang", text: markdowns.Ausbildung_und_Werdegang, id: 'AUSBILDUNG_UND_WERDEGANG' },
    { module: "9.4.1.2 Kenntnisse", text: markdowns.Kenntnisse, id: 'KENNTNISSE' },
    { module: "9.4.1.3 Projektreferenzen", text: markdowns.Projektreferenzen, id: 'PROJEKTREFERENZEN' },
    { module: "9.4.1.4 Sonstiges", text: markdowns.Sonstiges, id: 'SONSTIGES' },
    { module: "9.4.1.5 Lebenslauf-Exporte", text: markdowns.Lebenslauf_Exporte, id: 'LEBENSLAUF_EXPORTE' },
    { module: "9.4.2  Suchfilter", text: markdowns.Suchfilter, id: 'SUCHFILTER' },
    { module: "9.4.3 Kompetenzverwaltung", text: markdowns.Kompetenzverwaltung, id: 'KOMPETENZVERWALTUNG' },
    { module: "9.5. Skillmatrix", text: markdowns.Skillmatrix },
    { module: "9.6. Benutzer", text: markdowns.Benutzer },
    { module: "9.7. Rechte und Rollen", text: markdowns.Rechte_und_Rollen },
    { module: "10. Kontaktverwaltung", text: markdowns.Kontakte, id: 'KONTAKTE' },
    { module: "10.2. Aktionen", text: markdowns.Aktionen },
    { module: "11. Dokumentverwaltung", text: markdowns.Dokumente, id: 'DOKUMENTE' },
    { module: "11.2. Dokumentenübersicht", text: markdowns.Dokumentenuebersicht, id: 'Dokumentenuebersicht' },
    { module: "11.3. Wiedervorlage", text: markdowns.Wiedervorlage, id: 'WIEDERVORLAGE' },
    { module: "12. Systemeinstellungen", text: markdowns.Registry, id: 'REGISTRY' },
    { module: "12.2. Modulstammdaten", text: markdowns.Modulstammdaten, id: 'MODULSTAMMDATEN' },
    { module: "12.3.Vorlagen", text: markdowns.Vorlagen },
    { module: "12.4. Work-Instanzen", text: markdowns.Work_Instanzen },
]);

export default HELP_TABS;
